<mat-card>
  <mat-card-title>Update Title</mat-card-title>
  <form class="matrix-form" [formGroup]="titleForm" (ngSubmit)="saveTitle()">
    <div class="form-field">
      <label for="title">Title:</label>
      <input #firstInput id="title" autocomplete="off" type="text" name="title" formControlName="title" />
      @if (titleForm.get('title').errors?.required) {
        <div class="required">*</div>
      }
      <div class="validation-text">
        @if (titleForm.get('title').errors?.required) {
          <span>This is required</span>
        }
      </div>
    </div>
    <div class="buttons">
      <button mat-raised-button color="warn" type="button" (click)="cancel()">Cancel</button>
      <button mat-raised-button color="accent" type="submit">Save</button>
    </div>
  </form>
</mat-card>